const treatmentManagement = {
  subject: ["A-Stop", "P-Stop", "M-Strong"],
  type: [
    "동영상",
    "OX퀴즈",
    "워크시트",
    // "오디오",
    // "뇌활동-단어입력",
    "주관식",
    "객관식",
    "ADL",
  ],
  treatmentSubject: ["알코올 중독치료", "인지장애치료"],
  category: [
    {
      code: "C0001",
      name: "공통모듈",
      subject: "A-Stop",
      registrantName: "강무명",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      code: "C0002",
      name: "도입부",
      subject: "A-Stop",
      registrantName: "박무명",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      code: "C0003",
      name: "카테고리3",
      subject: "A-Stop",
      registrantName: "김무명",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      code: "C0004",
      name: "동기면담",
      subject: "P-Stop",
      registrantName: "최무명",
      updateTime: "2021-10-12 11:00:00",
    },
    {
      code: "C0005",
      name: "인지치료1",
      subject: "M-Strong",
      registrantName: "이무명",
      updateTime: "2021-10-12 11:00:00",
    },
  ],
  medicine: [
    {
      seq: 1,
      treatmentSubject: "알코올 중독치료",
      title: "명상을 위한 비디오",
      category: "공통모듈",
      level: 1,
      type: "동영상",
      media: "동영상",
      useYN: "사용",
      registrantName: "홍길동",
      updateTime: "2021-10-12 11:00:00",
      fileUrl: "",
    },
    {
      seq: 2,
      treatmentSubject: "알코올 중독치료",
      title: "동기면담",
      category: "공통모듈",
      level: 1,
      type: "OX퀴즈",
      media: "동영상",
      useYN: "미사용",
      registrantName: "박길동",
      updateTime: "2021-10-12 11:00:00",
      fileUrl: "",
    },
    {
      seq: 3,
      treatmentSubject: "알코올 중독치료",
      title: "기초 워크시트",
      category: "도입부",
      level: 1,
      type: "워크시트",
      media: "",
      useYN: "사용",
      registrantName: "최길동",
      updateTime: "2021-10-12 11:00:00",
      fileUrl: "",
    },
    {
      seq: 4,
      treatmentSubject: "인지장애치료",
      title: "인지치료 퀴즈",
      category: "도입부",
      level: 2,
      type: "주관식",
      media: "이미지",
      useYN: "사용",
      registrantName: "유길동",
      updateTime: "2021-10-12 11:00:00",
      fileUrl: "",
    },
    {
      seq: 5,
      treatmentSubject: "인지장애치료",
      title: "인지치료 퀴즈",
      category: "도입부",
      level: 2,
      type: "객관식",
      media: "동영상",
      useYN: "사용",
      registrantName: "유길동",
      updateTime: "2021-10-12 11:00:00",
      fileUrl: "",
    },
  ],
};

export default treatmentManagement;
